module.exports = __webpack_public_path__ + "img/dummy-img-600x400.956337c6.jpg";